// extracted by mini-css-extract-plugin
export default {"container":"PlayerShadowDom_container__CRd3f"};